var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideIconVirtualWaiting = function SvgSideIconVirtualWaiting(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.138 13.697h3.293c.312 0 .576-.265.576-.577V1.754c0-.312-.264-.577-.577-.577H1.898c-.312 0-.576.265-.576.577v11.39c0 .312.264.577.576.577h3.316c1.154-2.62 3.268-4.11 4.95-4.11 1.682 0 3.845 1.49 4.974 4.086zM20.16 1.754v11.39c0 .937-.769 1.73-1.73 1.73h-6.103v1.754h2.547c.12 0 .216.096.216.216v.337c0 .12-.096.216-.216.216h-9.42c-.12 0-.216-.096-.216-.216v-.36c0-.12.096-.217.217-.217h2.547V14.85H1.899c-.938 0-1.73-.769-1.73-1.73V1.754c0-.961.768-1.73 1.73-1.73h16.555c.937 0 1.706.769 1.706 1.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.164 2.523c1.73 0 3.124 1.418 3.124 3.124 0 1.73-1.418 3.124-3.124 3.124-1.706 0-3.1-1.418-3.1-3.124 0-1.73 1.37-3.124 3.1-3.124z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideIconVirtualWaiting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side-icon-VirtualWaiting.b5a30dcc8c275e3fc5e0de5350f0a158.svg";